// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"122863c6","455":"36bafbf0"}[chunkId] + ".chunk.js";
};